export default __webpack_public_path__ + "static/media/20.d2e4aa0c.svg";